import {createApi} from '@reduxjs/toolkit/query/react';
import baseQuery from 'src/redux/api/baseQuery';
import { IdetalleProyectoRequest, IinfoProyectoRequest, IinfoProyectoResponse, IobtenerProyectosRequest, IobtenerProyectosResponse, IproyectoResponse } from './types/proyectos';

/**
 * API para la gestión de proyectos
 * @see https://redux-toolkit.js.org/rtk-query/overview
 * @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
 *
 */
export const proyectosApi = createApi({
	reducerPath: 'proyectosApi',
	baseQuery,
	tagTypes: ['proyectos'],
	endpoints: (builder) => ({
		obtenerProyectos: builder.query<IobtenerProyectosResponse, IobtenerProyectosRequest>({
			query({estado, textoSearch, paginador}) {
				return {
					url: 'v1/proyectos',
					method: 'GET',
					credentials: 'include',
					params: {
						estado,
						textoSearch,
						...paginador,
					},
				};
			},
		}),
		obtenerProyectoPorId: builder.query<IproyectoResponse, IdetalleProyectoRequest>({
			query({proyectoId}) {
				return {
					url: `v1/proyectos/${proyectoId}`,
					method: 'GET',
					credentials: 'include',
				};
			},
		}),
		obtenerInformacionPorProyecto: builder.query<IinfoProyectoResponse, IinfoProyectoRequest>({
			query({proyectoId}) {
				return {
					url: `v1/proyectos/${proyectoId}/detalle`,
					method: 'GET',
					credentials: 'include',
				};
			},
		}),
	}),
});

export const {
	useLazyObtenerProyectosQuery,
	useObtenerProyectosQuery,
	useObtenerProyectoPorIdQuery,
	useObtenerInformacionPorProyectoQuery
} = proyectosApi;
